import React from 'react';

import TOLoginPageView from '../Views/TO/Login/LoginPageViewMobile';
import PasswordForm from '../Login/PasswordForm';
import JoinNow from '../Login/JoinNow';

import AppleButton from '../Views/TO/Login/AppleButton';
import GoogleButton from '../Views/TO/Login/GoogleButton';
import FacebookButton from '../Views/TO/Login/FacebookButton';

import AppVars from '../../AppVars.js'
import Logger from '../../Logger.js';
import Loader from '../Loader';

import { parseURL, setCookies, delCookies, checkCookie } from "account-portal-library/lib/helperFunctions";
import { withGotoUrl } from '../../withGotoUrl';
import { getGotoUrlFromCookies } from '../../gotoUrl';

import MfaSelectPage from './MfaSelectPage';
import MfaTextPage from './MfaTextPage';
import MfaEmailPage from './MfaEmailPage';
import MfaTrustPage from './MfaTrustPage';

let appVars = AppVars.getInstance();
let logger = Logger.getInstance();

class LoginPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      style: "TO",
      complete: false,
      payload: null,
      username: null,
      displayPhone: null,
      signInType: null,
      step: "USERNAME",
      isUsernameExists: null,
      isAccountLocked: null,
      implicitGoogle: false,
      implicitFacebook: false,
      implicitApple: false,
      phoneNumber: "",
    }
    this.saveSignInType = this.saveSignInType.bind(this);
    this.savePayload = this.savePayload.bind(this);
    this.saveUsername = this.saveUsername.bind(this);
    this.saveStep = this.saveStep.bind(this);
    this.saveDisplayPhone = this.saveDisplayPhone.bind(this);
    this.saveAccountLocked = this.saveAccountLocked.bind(this);
    this.saveUsernameExists = this.saveUsernameExists.bind(this);
    this.hideModalUsername = this.hideModalUsername.bind(this);
    this.hideModalLocked = this.hideModalLocked.bind(this);
    this.saveURI = this.saveURI.bind(this);
    this.savePhoneNumber = this.savePhoneNumber.bind(this);
  }

  async componentDidMount() {
    this.clearInfo()

    const url = window.location.search
    const urlParams = parseURL(url)

    if (Object.keys(urlParams).includes("provider")) {
      this.setState({
        implicitGoogle: urlParams["provider"] === "google",
        implicitFacebook: urlParams["provider"] === "facebook",
        implicitApple: urlParams["provider"] === "apple"
      })
    }

    const hash = window.location.hash


    if (hash.includes("dg") || hash.includes("DG")) {
      sessionStorage.AP_STYLE = "DG"
      this.setState({ style: "DG" })
    } else {
      sessionStorage.AP_STYLE = "TO"
    }

    //Check if user already has a session cookie on their browser
    const checkCookieResponse = await checkCookie(appVars.getBaseUrl(), appVars.getName(), appVars.getRealm());
    if (checkCookieResponse.valid) {
      this.setState({ complete: true })
    }
    this.setState({ loading: false })
  }

  saveURI() {
    if (this.state.style === "DG") {
      setCookies("login_uri", window.location.href, "/", appVars.getDomain())
    }
  }

  clearInfo() {
    sessionStorage.removeItem("AP_SSID")
    sessionStorage.removeItem("AP_authId")
    delCookies("amlbcookie", "", "/", appVars.getDomain())
  }

  savePhoneNumber(value) {
    this.setState({ phoneNumber: value });
  }

  saveUsername(value) {
    this.setState({ username: value })
  }

  savePayload(value) {
    this.setState({ payload: value });
  }

  saveSignInType(value) {
    this.setState({ signInType: value });
  }

  saveStep(value) {
    this.setState({ step: value })
  }

  saveAccountLocked(value) {
    this.setState({ isAccountLocked: value })
  }

  saveUsernameExists(value) {
    this.setState({ isUsernameExists: value })
  }

  saveDisplayPhone(value) {
    this.setState({ displayPhone: value })
  }

  hideModalUsername(value) {
    this.setState({ isUsernameExists: null })
  }

  hideModalLocked(value) {
    this.setState({ isAccountLocked: null })
  }

  redirectToSuccessUrl() {
    const successUrl = getGotoUrlFromCookies(['T']);
    window.location.replace(successUrl)
  }

  render() {
    if (this.state.loading === true) {
      return <Loader />
    }
    //Redirect user if they already have a session cookie
    if (this.state.complete) {
      this.redirectToSuccessUrl();
    } else if (this.state.implicitGoogle || this.state.implicitFacebook || this.state.implicitApple) {
      return (
        <div>
          {this.state.implicitGoogle === true && <GoogleButton implicitRegister={this.state.implicitGoogle} />}
          {this.state.implicitFacebook === true && <FacebookButton implicitRegister={this.state.implicitFacebook} />}
          {this.state.implicitApple === true && <AppleButton implicitRegister={this.state.implicitApple} />}
        </div>
      )
    } else {
      if (this.state.step === "USERNAME") {
        return (
          <TOLoginPageView
            payload={this.state.payload}
            username={this.state.username}
            isUsernameExists={this.state.isUsernameExists}
            isAccountLocked={this.state.isAccountLocked}
            displayPhone={this.state.displayPhone}
            savePayload={this.savePayload}
            saveDisplayPhone={this.saveDisplayPhone}
            saveSignInType={this.saveSignInType}
            saveUsername={this.saveUsername}
            saveStep={this.saveStep}
            saveAccountLocked={this.saveAccountLocked}
            saveUsernameExists={this.saveUsernameExists}
            hideModalLocked={this.hideModalLocked}
            hideModalUsername={this.hideModalUsername}
            style={sessionStorage.AP_STYLE}
            saveURI={this.saveURI}
          />
        )
      } else if (this.state.step === "JOIN") {
        return (
          <JoinNow style={this.state.style} username={this.state.username} />
        )
      } else if (this.state.step === "PASSWORD") {
        return (
          <PasswordForm style={this.state.style} username={this.state.username} signInType={this.state.signInType} savePayload={this.savePayload} saveStep={this.saveStep} payload={this.state.payload} savePhoneNumber={this.savePhoneNumber} />
        )
      } else if (this.state.step === "SELECT") {
        return (
          <MfaSelectPage style={this.state.style} savePayload={this.savePayload} payload={this.state.payload} saveStep={this.saveStep} phoneNumber={this.state.phoneNumber} />
        )
      } else if (this.state.step === "TEXT_CODE") {
        return (
          <MfaTextPage style={this.state.style} savePayload={this.savePayload} payload={this.state.payload} saveStep={this.saveStep} phoneNumber={this.state.phoneNumber} />
        )
      } else if (this.state.step === "EMAIL_CODE") {
        return (
          <MfaEmailPage style={this.state.style} savePayload={this.savePayload} payload={this.state.payload} saveStep={this.saveStep} email={this.state.email} />
        )
      } else if (this.state.step === "TRUST") {
        return (
          <MfaTrustPage style={this.state.style} savePayload={this.savePayload} payload={this.state.payload} saveStep={this.saveStep} />
        )
      }
    }
  }
}


export default withGotoUrl(LoginPage);